import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import { useGetAllBranchesQuery } from "../toolkitServices/branchApi";
import { useGetAllCategoriesQuery } from "../toolkitServices/categoryApi";
import { useGetAllProductsQuery } from "../toolkitServices/productApi";
import {
  useGetAllCountersQuery,
  useGetCountersQuery,
} from "../toolkitServices/counterApi"; // 🔹 NEW

import { useForm } from "react-hook-form";
import { setCategoryList } from "../slices/categorySlice";
import { setProductList } from "../slices/productSlice";
import { setBranchList } from "../slices/branchSlice";
import { setCounterList } from "../slices/counterSlice"; // 🔹 NEW

import URDForm from "../components/urd/URDForm";

const CreateURD = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { data: branches } = useGetAllBranchesQuery();

  const { data: categories } = useGetAllCategoriesQuery({
    page: 1,
    limit: 1000,
    search: "",
  });

  const { data: products } = useGetAllProductsQuery({
    page: 1,
    limit: 2000,
    search: "",
  });

  // 🔹 Counters list (for dropdown)
  const { data: counters } = useGetCountersQuery({
    page: 1,
    limit: 2000,
    search: "",
  });

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
    watch,
    control,
  } = useForm();

  useEffect(() => {
    if (categories?.data?.length) {
      dispatch(setCategoryList(categories?.data));
    }
    if (products?.data?.length) {
      dispatch(setProductList(products?.data));
    }
    if (branches?.data?.length) {
      dispatch(setBranchList(branches?.data));
    }
    if (counters?.data?.length) {
      dispatch(setCounterList(counters?.data)); // 🔹 push counters into slice
    }
  }, [categories, products, branches, counters, dispatch]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.ctrlKey && e.key === "Backspace") {
        e.preventDefault();
        navigate(-1);
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [navigate]);

  const onSubmit = () => {};

  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
      className="max-w-8xl mx-auto rounded-xl relative max-h-[90vh] overflow-y-auto"
    >
      <URDForm
        handleSubmit={handleSubmit}
        register={register}
        onSubmit={onSubmit}
        errors={errors}
        control={control}
      />
    </motion.div>
  );
};

export default CreateURD;
